export const products = [
  {
    id: 1,
    name: 'Organic In-Shell Hazelnuts — 5 kg Jute Bag',
    nameRo: 'Alune Ecologice în Coajă — Sac de Iută 5 kg',
    weight: '5 kg',
    price: 45,
    pricePerKg: 9,
    bestseller: true,
    category: 'hazelnuts',
    comingSoon: false,
    description:
      'Certified organic in-shell hazelnuts, naturally dried and packed in a breathable 5 kg jute bag to preserve freshness and crunch.',
    descriptionRo:
      'Alune ecologice certificate în coajă, uscate natural și ambalate în sac de iută de 5 kg pentru păstrarea prospețimii și a gustului autentic.',
    image: '/images/products/hazelnuts/jute-5kg.png'
  },
  {
    id: 2,
    name: 'Organic In-Shell Hazelnuts — 10 kg Jute Bag',
    nameRo: 'Alune Ecologice în Coajă — Sac de Iută 10 kg',
    weight: '10 kg',
    price: 90,
    pricePerKg: 9,
    bestseller: true,
    category: 'hazelnuts',
    comingSoon: false,
    description:
      'Certified organic in-shell hazelnuts packed in a sturdy 10 kg jute bag. Ideal for families, artisanal kitchens, and long-term pantry storage.',
    descriptionRo:
      'Alune ecologice certificate în coajă, ambalate în sac rezistent de iută de 10 kg. Ideale pentru familie, cofetărie artizanală și păstrare îndelungată.',
    image: '/images/products/hazelnuts/jute-10kg.png'
  },
  {
    id: 3,
    name: 'Organic In-Shell Hazelnuts — 15 kg Jute Bag',
    nameRo: 'Alune Ecologice în Coajă — Sac de Iută 15 kg',
    weight: '15 kg',
    price: 135,
    pricePerKg: 9,
    bestseller: false,
    category: 'hazelnuts',
    comingSoon: false,
    description:
      'Generous 15 kg jute bag of certified organic in-shell hazelnuts. Naturally protected by their shell for lasting harvest flavor.',
    descriptionRo:
      'Sac generos de iută de 15 kg cu alune ecologice certificate în coajă. Protejate natural de coajă pentru păstrarea aromei proaspete de recoltă.',
    image: '/images/products/hazelnuts/jute-15kg.png'
  },
  {
    id: 4,
    name: 'Organic In-Shell Hazelnuts — 20 kg Jute Bag',
    nameRo: 'Alune Ecologice în Coajă — Sac de Iută 20 kg',
    weight: '20 kg',
    price: 180,
    pricePerKg: 9,
    bestseller: false,
    category: 'hazelnuts',
    comingSoon: false,
    description:
      'Bulk 20 kg jute bag of certified organic in-shell hazelnuts from our orchard harvest, suited for larger orders and enthusiasts.',
    descriptionRo:
      'Sac de iută de 20 kg cu alune ecologice certificate în coajă din recolta livezii noastre, potrivit pentru comenzi mai mari și pasionați.',
    image: '/images/products/hazelnuts/jute-20kg.png'
  },
  {
    id: 5,
    name: 'Organic Shelled Hazelnuts (Kernels)',
    nameRo: 'Alune Ecologice Decojite (Miez)',
    weight: '',
    price: null,
    category: 'hazelnuts',
    comingSoon: true,
    description:
      'Cleaned organic hazelnut kernels, freshly cracked to order for snacking, roasting, and pastry creations. Available soon.',
    descriptionRo:
      'Miez ecologic de alune, spart proaspăt pentru gustări, prăjit și deserturi artizanale. Disponibil în curând.',
    image: '/images/products/hazelnuts/hazlenuts_500.png'
  },
  {
    id: 11,
    name: 'Fresh White Truffles — 50 g',
    nameRo: 'Trufe Albe Proaspete — 50 g',
    weight: '50 g',
    price: null,
    category: 'truffles',
    comingSoon: true,
    description: 'White truffles (Tuber Magnatum), 50 g. Coming soon.',
    descriptionRo: 'Trufe albe (Tuber Magnatum), 50 g. În curând.',
    image: '/images/products/truffles/truffles-alt.png'
  },
  {
    id: 16,
    name: 'Fresh White Truffles — 100 g',
    nameRo: 'Trufe Albe Proaspete — 100 g',
    weight: '100 g',
    price: null,
    category: 'truffles',
    comingSoon: true,
    description: 'White truffles (Tuber Magnatum), 100 g. Coming soon.',
    descriptionRo: 'Trufe albe (Tuber Magnatum), 100 g. În curând.',
    image: '/images/products/truffles/truffles.png'
  },
  {
    id: 17,
    name: 'Fresh White Truffles — 300 g',
    nameRo: 'Trufe Albe Proaspete — 300 g',
    weight: '300 g',
    price: null,
    category: 'truffles',
    comingSoon: true,
    description: 'White truffles (Tuber Magnatum), 300 g. Coming soon.',
    descriptionRo: 'Trufe albe (Tuber Magnatum), 300 g. În curând.',
    image: '/images/products/truffles/truffle.png'
  },
  {
    id: 9,
    name: 'Hazelnut Snaps — 250 ml',
    nameRo: 'Țuică de Alune — 250 ml',
    weight: '250 ml',
    price: null,
    category: 'snacks',
    comingSoon: true,
    description: 'Hazelnut spirit in a 250 ml bottle. Coming soon.',
    descriptionRo: 'Țuică de alune la sticla de 250 ml. În curând.',
    image: '/images/products/snaps/snaps_250.png'
  },
  {
    id: 7,
    name: 'Hazelnut Snaps — 500 ml',
    nameRo: 'Țuică de Alune — 500 ml',
    weight: '500 ml',
    price: null,
    category: 'snacks',
    comingSoon: true,
    description: 'Hazelnut spirit in a 500 ml bottle. Coming soon.',
    descriptionRo: 'Țuică de alune la sticla de 500 ml. În curând.',
    image: '/images/products/snaps/snaps_500.png'
  },
  {
    id: 6,
    name: 'Hazelnut Snaps — 1 L',
    nameRo: 'Țuică de Alune — 1 L',
    weight: '1 L',
    price: null,
    category: 'snacks',
    comingSoon: true,
    description: 'Hazelnut spirit in a 1 L bottle. Coming soon.',
    descriptionRo: 'Țuică de alune la sticla de 1 L. În curând.',
    image: '/images/products/snaps/snaps_1.png'
  }
];

export const categories = [
  { id: 'hazelnuts', name: 'Organic Hazelnuts', nameRo: 'Alune Ecologice' },
  { id: 'truffles', name: 'White Truffles', nameRo: 'Trufe Albe' },
  { id: 'snacks', name: 'Hazelnut Snaps', nameRo: 'Țuică de Alune' }
];
